
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { Product } from "@/types/services";

export const useProductsState = () => {
  const { toast } = useToast();
  const [products, setProducts] = useState<Product[]>([{ 
    name: "", 
    price: 0, 
    description: "",
    images: [] 
  }]);
  const [isGeneratingDescription, setIsGeneratingDescription] = useState(false);
  const [descriptionProductIndex, setDescriptionProductIndex] = useState<number | null>(null);
  
  // Check if form is valid (at least one product with name and price)
  const isFormValid = products.some(product => product.name.trim() !== "" && product.price > 0);

  const handlePriceChange = (index: number, value: string) => {
    const newProducts = [...products];
    
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      newProducts[index] = {
        ...newProducts[index],
        price: value === '' ? 0 : parseFloat(value)
      };
      setProducts(newProducts);
    }
  };

  const addProduct = () => {
    setProducts([...products, { name: "", price: 0, description: "", images: [] }]);
  };

  const removeProduct = (index: number) => {
    products[index].images.forEach(image => URL.revokeObjectURL(image.preview));
    const newProducts = products.filter((_, i) => i !== index);
    setProducts(newProducts);
  };

  const useSuggestion = (suggestion: { name: string; price: number; description: string }) => {
    const newProducts = [...products];
    
    let emptyIndex = newProducts.findIndex(p => p.name === "" && p.price === 0 && p.images.length === 0);
    
    if (emptyIndex === -1) {
      newProducts.push({
        name: suggestion.name,
        price: suggestion.price,
        description: suggestion.description || "",
        images: []
      });
    } else {
      newProducts[emptyIndex] = {
        ...newProducts[emptyIndex],
        name: suggestion.name,
        price: suggestion.price,
        description: suggestion.description || ""
      };
    }
    
    setProducts(newProducts);
    
    toast({
      title: "Service Added",
      description: `${suggestion.name} has been added to your services.`
    });
  };

  return {
    products,
    setProducts,
    isFormValid,
    handlePriceChange,
    addProduct,
    removeProduct,
    useSuggestion,
    isGeneratingDescription,
    setIsGeneratingDescription,
    descriptionProductIndex,
    setDescriptionProductIndex
  };
};
